import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function msgtcaPosto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@msgtcaPosto/FIND_DATA':
      case '@msgtcaPosto/UPDATE_DATA':
      case '@msgtcaPosto/DELETE_DATA':
      case '@msgtcaPosto/STORE_DATA':
      case '@msgtcaPosto/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@msgtcaPosto/SUCCESS_REMOVE':
      case '@msgtcaPosto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@msgtcaPosto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@msgtcaPosto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@msgtcaPosto/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
